import React, { useContext, useEffect, useState } from "react";
import { SERVER_IP, ud, jwt } from "../Server";
import axios from "axios";
import UserContext from "../context/UserContext";
import NoDataFound from "../common/NoDataFound";
import { CloseIcon } from "../assets/Icons";

export default function Modal(props) {
  const context = useContext(UserContext);
  const { updateddata } = context;

  const [data, setData] = useState({});
  const getData = async (faq_id) => {
    try {
      const data = { faq_id };
      let headers = {
        user_id: ud.id.toString(),
        session_id: ud.session_id.toString(),
        user_type: ud.usertype.toString(),
        main_id: ud.main_id.toString(),
        jwt_token: jwt,
        c_id: ud.c_id.toString(),
      };
      const result = await axios.post(`${SERVER_IP}/userfaq/log`, data, {
        withCredentials: true,
        headers: headers,
      });
      if (result.data.error === false) {
        setData(result.data);
      } else {
        setData(result.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getData(props.faq_id);
  }, [updateddata]);

  return (
    <>
      {/* mh-50 fixed-top */}
      <div className="modal-dialog modal-lg fixed-top" role="document" key={props.faq_id}>
        <div className="modal-content">
          <div className="modal-header bg-light border-radius-top-15 mb-3">
            <h5 className="modal-title" id="logModalLabel">
              Edit Logs
            </h5>
            <button
              data-dismiss="modal"
              className="close-s"
              type="button"
              data-toggle="tooltip"
              data-placement="top"
              title="Close"
            >
              <CloseIcon />
            </button>
          </div>

          <div className="scrollable px-0">
            {Object.keys(data).length === 0 ? (
              // Loader
              <div className="d-flex justify-content-center">
                <div className="spinner-border" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            ) : // No data modal
            data.logresult.length === 0 ? (
              <>
                <div className="modal-body">
                  <ul className="list-group">
                    {/* <li className="list-group-item disabled">No record found</li> */}
                    <NoDataFound headText="No edit logs found" customCls="editlogs" />
                  </ul>
                </div>
                {/* Data modal */}
              </>
            ) : (
              data.logresult.map((element) => {
                return (
                  <div className="modal-body edithistory" key={element.id}>
                    <div className="editheading">
                      <h6 className="mb-1">
                        <strong>Edited By:</strong> {element.modify_by}
                      </h6>
                      <h6>
                        <strong>Edited On:</strong> {new Date(element.updated_at).toLocaleString()}
                      </h6>
                    </div>
                    <ul className="list-group mt-3">
                      <li className="list-group-item">
                        <strong>New Title: </strong> {element.new_title}
                      </li>
                      <li className="list-group-item">
                        <strong>New Description:</strong> {element.new_description}
                      </li>
                      <li className="list-group-item">
                        <strong>Old Title: </strong>
                        {element.old_title}
                      </li>
                      <li className="list-group-item">
                        <strong>Old Description: </strong> {element.old_description}
                      </li>
                    </ul>
                    <hr />
                  </div>
                );
              })
            )}
          </div>
        </div>
      </div>
    </>
  );
}
